import {useSelector} from 'react-redux';
import {getGradeNameById} from '../utils/getGradeNameById';

const FORM_5_PATTERN = /form\s*5/i;

export function useAZRevision() {
  const kids = useSelector((state) => state.general.kids);
  const grades = useSelector((state) => state.general.grades);

  const gradeId = kids?.[0]?.gradeId;

  const gradeName = getGradeNameById({
    grades,
    id: gradeId,
    fallback: '',
  });

  return !FORM_5_PATTERN.test(gradeName);
}

export default useAZRevision;
